import { Firebase } from "@/services/firebase";

// properties
const state = {
  user: {
    loggedIn: false,
    checking: true,
    data: null,
    team: null,
  },
};

const mutations = {
  SET_LOGGED_IN(state, value) {
    state.user.loggedIn = value;
  },
  SET_CHECKING(state, value) {
    state.user.checking = value;
  },
  SET_USER(state, data) {
    state.user.data = data;
  },
  SET_TEAM(state, team) {
    state.user.team = team;
  },
};

const getters = {
  getTeam(state) {
    return state.user.team;
  },
};

const actions = {
  async setTeamInModules({ dispatch }, teamId) {
    // set team in all modules
    dispatch(
      "team/setPathVars",
      {
        teamId,
      },
      { root: true }
    );
    dispatch(
      "team-lists-library/setPathVars",
      {
        teamId,
      },
      { root: true }
    );
    dispatch(
      "team-tasks-library/setPathVars",
      {
        teamId,
      },
      { root: true }
    );
    dispatch(
      "tasks/setPathVars",
      {
        teamId,
      },
      { root: true }
    );
    dispatch(
      "lists/setPathVars",
      {
        teamId,
      },
      { root: true }
    );
    dispatch(
      "project/setPathVars",
      {
        teamId,
        projectId: docketData.install_id,
      },
      { root: true }
    );
  },

  async authenticate({ commit }, { email, password }) {
    await Firebase.auth().setPersistence(Firebase.auth.Auth.Persistence.LOCAL);
    return Firebase.auth().signInWithEmailAndPassword(email, password);
  },

  async fetchUser({ commit, dispatch, rootState }, user) {
    if (user) {
      // get token
      let idTokenResult = await Firebase.auth().currentUser.getIdTokenResult();

      // set team
      commit("SET_TEAM", idTokenResult.claims.team);
      await dispatch("setTeamInModules", idTokenResult.claims.team);

      let subscription = idTokenResult.claims.stripeRole;

      if (!subscription) {
        subscription = idTokenResult.claims.demo ? "demo" : null;
      }

      // if (idTokenResult.claims.admin) {
      //   subscription = "admin";
      // }

      if (subscription) {
        console.log(`${rootState.ui.betaDays} days left on your trial!`);
        await dispatch("project/openDBChannel", {}, { root: true });
      }

      await commit("SET_USER", {
        id: user.uid,
        displayName: user.displayName,
        email: user.email,
        subscription,
      });
      commit("SET_LOGGED_IN", user !== null);
      commit("SET_CHECKING", false);
    } else {
      await dispatch(
        "closeChannels",
        [
          "project/closeDBChannel",
          "lists/closeDBChannel",
          "tasks/closeDBChannel",
        ],
        true
      );
      localStorage.removeItem("docketCurrentListId");
      commit("SET_USER", null);
      commit("SET_TEAM", null);
      commit("lists/SET_ITEMS", {}, { root: true });
      commit("tasks/SET_ITEMS", {}, { root: true });
      commit("SET_LOGGED_IN", null);
      commit("SET_CHECKING", false);
    }
  },

  async closeChannels({ dispatch }, channels = [], clear = false) {
    return channels.forEach(async (name) => {
      await dispatch(name, { clearModule: clear }, { root: true });
    });
  },

  async signOut() {
    await Firebase.auth().signOut();
    // window.location.reload();
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
